export default __webpack_public_path__ + "static/media/320x180.3bbb1b99.jpg";